class SelectorMapping {
  static mapping = {
    'gsc-form': 'form.gsc-search-box',
    'gsc-form__submit-btn': 'button.gsc-search-button',
    'gsc-form__input': 'input.gsc-input[name="search"]',
    'gsc-results': '.gsc-wrapper',
    'gsc-results__container': '.gsc-results-wrapper-nooverlay',
    'gsc-results__result-count': '#resInfo-0',
    'gsc-results__info-container': '.gsc-above-wrapper-area-container tbody tr',
    'gsc-results__info-content': '.gsc-above-wrapper-area',
    'gsc-results__sort-container': 'td.gsc-orderby-container',
    'gsc-results__sort': 'div.gsc-orderby',
    'gsc-results__pagination-container': '.gsc-cursor-box',
    'gsc-results__pagination-link': '.gsc-cursor-page',
    'gsc-results__no-results-container': '.gs-no-results-result',
    'gsc-results__snippet': '.gs-snippet',
    'gsc-item': '.gs-result',
    'gsc-item__container': '.gsc-webResult.gsc-result',
    'gsc-item__title-container': 'div.gs-title',
    'gsc-item__title': 'a.gs-title',
    'gsc-item__breadcrumbs': '.gsc-url-top',
    'gsc-item__breadcrumbs-crumb': '.gs-visibleUrl-breadcrumb span',
    'gsc-item__content-container': '.gsc-table-result',
    'gsc-item__image-container': 'div.gs-image-box',
    'gsc-item__image-link': 'a.gs-image',
    'gsc-item__image': 'img.gs-image',
    'gsc-misc__branding': '.gcsc-more-maybe-branding-root',
    'gsc-misc__recaptcha': 'div.gs-webResult.gs-captcha-outer-wrapper',
    'gsc-misc__control-wrapper': 'div.gsc-control-wrapper-cse',
  };

  /**
   * Takes n strings as arguments and returns their respective
   * Google selector.
   *
   * @param {...String} btpSelectors
   * @returns { String | Array<String> }
   */
  static get(...btpSelectors) {
    if (btpSelectors.length === 1) {
      const [selector] = btpSelectors;

      return this.mapping[selector];
    }

    return btpSelectors.map((selector) => this.mapping[selector]);
  }

  static entries() {
    return Object.entries(this.mapping);
  }
}

export default SelectorMapping;
